import { ProjectDataPerimetro } from '../entities/project-data-perimetro.entity';
import { ProjectData } from '../entities/project-data.entity';

export class CleanPerimeters {

	public clean(perimeters: ProjectDataPerimetro[]): ProjectDataPerimetro[] {
		// Comprobar que tiene perímetros.
		if (!perimeters || perimeters.length === 0) return [];

		// Clonar perímetros.
		let clonePerimeters = JSON.parse(JSON.stringify(perimeters));

		// Se almacenan los perímetros corregidos.
		let newsPerimeters = [];

		// Por cada perímetro comprobar que no se replican postes y que tiene más de un poste.
		for (let ip = 0; ip < clonePerimeters.length; ip++) {
			// Obtener el perímetro.
			let perimeter = clonePerimeters[ip];
			//console.log('Perimetro ' + ip);

			// Un perímetro debe tener como mínimo 2 postes y no estar en el mismo lugar.
			if (perimeter.coordenadas.length > 1) {
				//console.log('>> coordenadas ' + perimeter.coordenadas.length);
				let anterior = perimeter.coordenadas[0];
				let newCoor = [];
				newCoor.push(perimeter.coordenadas[0]);
				//console.log(perimeter.coordenadas[0]);
				for (let ic = 1; ic < perimeter.coordenadas.length; ic++) {
					let coor = perimeter.coordenadas[ic];
					if (!(anterior.lat === coor.lat && anterior.lng === coor.lng)) {
						// Son distintas.
						anterior = coor;
						newCoor.push(coor);
						//console.log('SI :: ' + JSON.stringify(coor));
					}
					//else console.log('NO :: ' + JSON.stringify(coor));
				}

				// Aceptar si tiene más de una coordenada.
				if (newCoor.length > 1) {
					console.log('INSERTAR PERÍMETRO');
					perimeter.coordenadas = newCoor;
					newsPerimeters.push(perimeter);
				}
			}
		}

		return newsPerimeters;
	}


	// devuelve true si todos los perímetros tienen prodcuto asignado.
	public exsitsProducts(datas: ProjectData): boolean {
		// El proyecto debe ecistir, tener un array de perímetros y que no este vacía.
		if (!datas || !datas.perimetro || datas.perimetro.length === 0) return false;

		for (let i = 0; i < datas.perimetro.length; i++) {
			let p = datas.perimetro[i];
			// Los perímetros deben tener como mínimo dos postes.
			if (p.coordenadas.length < 2) return false;
			// Deben tener un producto.
			if (!p.producto) return false;
			// Deben tener un tipo de panel.
			if (!p.producto.panel) return false;
			// Deben tener un tipo de tipoPanel.
			if (!p.producto.tipoPanel) return false;
			// Hay puertas pero no se ha seleccionado el tipo.
			console.log('Puertas ' + p.puertas.length);
			for (let d of p.puertas) {
				if (!d.puerta) return false;
			}
		}

		return true;
	}

}